import "core-js/modules/es.array.fill.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["width", "height"];
var _hoisted_2 = ["fill"];
var _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.5 13.4062L11.3438 15.3507L15.5 9.46875",
  stroke: "white",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.size,
    height: $props.size,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("circle", {
    cx: "12",
    cy: "12.25",
    r: "12",
    fill: $props.fill
  }, null, 8, _hoisted_2), _hoisted_3], 8, _hoisted_1);
}